import axios from "axios";
import { Selectbox } from "../Shared";



export const MONTHS = ["January", "February", "March", "April", "May", "June",
"July", "August", "September", "October", "November", "December"];

export const WEEKDAYS = ["Sun","Mon","Tue","Wed","Thur","Fri","Sat"];

export const bgChange = (item) => {
    let colors = {}
  switch(item){
  case "1" :
    colors.bgcolor="green"
    colors.color= "pink"
  break;
  case "2" :
    colors.bgcolor="#70AD47"
    colors.color= "white"
  break;
  case "3" :
    colors.bgcolor="green"
    colors.color= "white"
  break;
  case "4" :
    colors.bgcolor="#ED7D31"
    colors.color= "white"
  break;
  default:
    colors.bgcolor="grey"
    colors.color= "var(--plsBlue)"
    break;
}
  return colors
  }
  

  export const currentStatusColor = (stat) => {
    let newstatuscolor
    switch(stat){
case "11":
  newstatuscolor="#70AD47";
  break;
  case "12":
  newstatuscolor="rgb(255,255,0,.7)";
  break;
  case "13":
    newstatuscolor="#ED7D31";
    break;
    case "14":
      newstatuscolor="rgb(255,0,0,.4)";
      break;
      default:
        newstatuscolor="rgb(0,0,0,.3)"
    }
    return newstatuscolor
  }

  export const addHours = (date, hours) => {
    date.setHours(date.getHours() + hours);
  
    return date;
  }

export const NumberFormatter = ( number ) => {
  const formattedNumber = number?.toLocaleString('en-US'); // 'en-US' for US locale formatting

  return (
    formattedNumber
  );
}


export const presses = [
    { name: 'Large Miller', minWidth: 26, minLength: 20, maxWidth: 40, maxLength: 28, piecesPerHour: 1200, perHourCost: 70, mrCost: 75 },
    { name: 'Small Miller', minWidth: 20, minLength: 13, maxWidth: 28, maxLength: 20, piecesPerHour: 1800, perHourCost: 55, mrCost: 55 },
    { name: 'Thompson', minWidth: 12, minLength: 9, maxWidth: 40, maxLength: 28, piecesPerHour: 500, perHourCost: 100, mrCost: 55 },
    { name: 'Saroglia', minWidth: 12, minLength: 9, maxWidth: 28, maxLength: 20, piecesPerHour: 1200, perHourCost: 55, mrCost: 55 },
    { name: 'Yawa', minWidth: 13, minLength: 10, maxWidth: 28, maxLength: 20, piecesPerHour: 1200, perHourCost: 55, mrCost: 55 },
    { name: 'Large Kluge', minWidth: 15, minLength: 11, maxWidth: 21, maxLength: 13, piecesPerHour: 1500, perHourCost: 55, mrCost: 55 },
    { name: 'Small Kluge', minWidth: 11, minLength: 8.5, maxWidth: 18, maxLength: 12, piecesPerHour: 1800, perHourCost: 55, mrCost: 55 },
];